"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { trans } from "@/service/i18n/i18n";

const VISIBLE_LIMIT = 5;

export function MedBoxList({ boxes }: { boxes: string[] }) {
  const [expanded, setExpanded] = useState(false);

  const filled = boxes.filter(Boolean);
  if (!filled.length) return <>-</>;

  const hasMore = filled.length > VISIBLE_LIMIT;
  const shown = expanded ? filled : filled.slice(0, VISIBLE_LIMIT);

  return (
    <span>
      {shown.join(", ")}
      {hasMore && (
        <Button
          variant="inline"
          size="inline"
          className="ml-1 border-t-0! text-xs"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? trans("meds.boxes.collapse") : trans("meds.boxes.expand")}
        </Button>
      )}
    </span>
  );
}
